<div matBadgeColor="warn" matBadgePosition="above after" [matBadge]="messageCount$ | async">
  @if (isQuotingInProgress$ | async) {
    <span class="indicator quote primary-background-100">
      <span class="progress primary-background" [style.width]="(progress$ | async) + '%'"></span>
      <span class="overlay primary-contrast-color" i18n>Quoting...</span>
    </span>
  }
  @if (isQuotingCompleted$ | async) {
    <span class="indicator quote primary-background">
      <span class="overlay primary-contrast-color" i18n>
            Quoted
        </span>
    </span>
  }
  @if (isQuote$ | async) {
    <span class="indicator quote">
      <span class="overlay" i18n>
            Preparing
        </span>
    </span>
  }
  @if (isManifested$ | async) {
    <span class="indicator manifested">
      <span class="overlay" i18n>
            Submitted
        </span>
    </span>
  }
  @if (isInTransit$ | async) {
    <span class="indicator in-transit">
      <span class="overlay" i18n>
            In-Transit
        </span>
    </span>
  }
  @if (isDelivered$ | async) {
    <span class="indicator delivered">
      <span class="overlay" i18n>
            Delivered
        </span>
    </span>
  }
  @if (isException$ | async) {
    <span class="indicator exception">
      <span class="overlay" i18n>
            Exception
        </span>
    </span>
  }
  @if (isVoid$ | async) {
    <span class="indicator void">
      <span class="overlay" i18n>
            Void
        </span>
    </span>
  }
</div>
